import React from "react";
import { Users, UserCheck, Clock } from "lucide-react";

/* ===================== COMPONENTS ===================== */
import SummaryCard from "./SummaryCard";

/* ===================== STYLES ===================== */
import styles from "./SummaryGrid.module.scss";

export default function SummaryGrid({ data }) {
  // Graceful fallback to 0 if data isn't fully loaded yet
  const safeData = {
    totalUsers: data?.totalUsers || 0,
    activeUsers: data?.activeUsers || 0,
    pendingInvites: data?.pendingInvites || 0,
  };

  return (
    <div className={styles["admin-sum-grid__wrapper"]}>
      <SummaryCard
        icon={<Users size={24} strokeWidth={2.5} />}
        title="Total Users"
        value={safeData.totalUsers}
      />

      <SummaryCard
        icon={<UserCheck size={24} strokeWidth={2.5} />}
        title="Active Users"
        value={safeData.activeUsers}
      />

      <SummaryCard
        icon={<Clock size={24} strokeWidth={2.5} />}
        title="Pending Invites"
        value={safeData.pendingInvites}
      />
    </div>
  );
}
